import { createSimpleFunctional } from '@/util'

export const VCardSubtitle = createSimpleFunctional('v-card-subtitle')
